import {
  connectFirestoreEmulator,
  type Firestore,
} from 'firebase/firestore';
import { firebaseClient } from './client';

let emulatorConnected = false;

export function getFirestoreInstance(): Firestore {
  const { db } = firebaseClient;

  if (!emulatorConnected && process.env.NODE_ENV !== 'production') {
    emulatorConnected = true;
    connectFirestoreEmulator(db, 'localhost', 8080);
  }

  return db;
}
